import { render } from "./Client_Profile.vue?vue&type=template&id=57ac5749&scoped=true"
import script from "./Client_Profile.vue?vue&type=script&lang=js"
export * from "./Client_Profile.vue?vue&type=script&lang=js"

import "./Client_Profile.vue?vue&type=style&index=0&id=57ac5749&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ac5749"]])

export default __exports__